module.exports = __webpack_public_path__ + "img/1sspdJHXPIRwHsh-EGPfKQviQi1U8qplZ.a5aeee43.png";